var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"radio-btn",class:{ active: _vm.model === _vm.value },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("buttonText")],2)}
var staticRenderFns = []

export { render, staticRenderFns }